import { Box } from "@mui/material";
import { Form, Formik } from "formik";
import ModalComponent from "../../components/ModalComponent";
import { useCollaboratorForm } from "../../hooks/pages/useCollaboratorForm";
import { typesCollaborator } from "../../helpers";
import SelectInputAutoComplete from "../../components/SelectInputAutoComplete";

export default function CollaboratorCreate({
  open,
  setOpen,
  collaborator,
  getList,
  teams,
  pessoas
}) {
  const { initialValues, validationSchema, onSubmit } = useCollaboratorForm({
    collaborator,
    getCollaborators: getList,
    handleClose: setOpen
  });

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          isSubmitting,
          setFieldValue
        }) => {
          return (
            <Form id="form-collaborator">
              <ModalComponent
                open={open}
                title="Dados do Colaborador"
                maxWidth={"sm"}
                handleOpen={setOpen}
                buttonOkType={"submit"}
                disabledClick={isSubmitting}
                buttonForm="form-collaborator"
              >
                <SelectInputAutoComplete
                  label="Tipo Colaborador"
                  labelId={"IdTipoColaborador"}
                  name={"IdTipoColaborador"}
                  value={values.IdTipoColaborador}
                  onChange={value => setFieldValue("IdTipoColaborador", value)}
                  helperText={
                    touched.IdTipoColaborador && errors.IdTipoColaborador
                  }
                  error={Boolean(
                    touched.IdTipoColaborador && errors.IdTipoColaborador
                  )}
                  options={typesCollaborator}
                  emptyText="Nenhuma opção encontrada"
                />

                <SelectInputAutoComplete
                  label="Pessoa"
                  labelId={"IdPessoa"}
                  name={"IdPessoa"}
                  value={values.IdPessoa}
                  onChange={value => setFieldValue("IdPessoa", value)}
                  helperText={touched.IdPessoa && errors.IdPessoa}
                  error={Boolean(touched.IdPessoa && errors.IdPessoa)}
                  options={pessoas}
                  emptyText="Nenhuma opção encontrada"
                />

                <SelectInputAutoComplete
                  label="Equipe"
                  labelId={"IdEquipe"}
                  name={"IdEquipe"}
                  value={values.IdEquipe}
                  onChange={value => setFieldValue("IdEquipe", value)}
                  helperText={touched.IdEquipe && errors.IdEquipe}
                  error={Boolean(touched.IdEquipe && errors.IdEquipe)}
                  options={teams}
                  emptyText="Nenhuma opção encontrada"
                />
              </ModalComponent>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
}
